export const version = {
  sha: '6d1b47f08d92f2da860e19d75177e1975b2dfced'
};
